import React, { useRef, useEffect } from 'react'

const LONG_PRESS_DURATION = 700
const MOVE_TOLERANCE = 10

const LongPressRow = ({ children, onComplete, active }) => {
  const rowRef = useRef(null)
  const animFrameRef = useRef(null)
  const startTimeRef = useRef(null)
  const startXRef = useRef(null)
  const startYRef = useRef(null)
  const isPressing = useRef(false)

  useEffect(() => {
    const el = rowRef.current
    if (!el) return
    if (active) {
      el.classList.remove('lp-pressing')
      el.style.removeProperty('--lp-p')
      el.classList.add('lp-active')
    } else {
      el.classList.remove('lp-active')
    }
  }, [active])

  const stopAnimation = () => {
    if (animFrameRef.current) {
      cancelAnimationFrame(animFrameRef.current)
      animFrameRef.current = null
    }
  }

  const cancelPress = () => {
    if (!isPressing.current) return
    isPressing.current = false
    stopAnimation()
    startTimeRef.current = null
    const el = rowRef.current
    if (el) {
      el.classList.remove('lp-pressing')
      el.style.removeProperty('--lp-p')
    }
  }

  const handlePointerDown = (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return
    isPressing.current = true
    startTimeRef.current = Date.now()
    startXRef.current = e.clientX
    startYRef.current = e.clientY

    const el = rowRef.current
    el?.classList.add('lp-pressing')

    const animate = () => {
      if (!isPressing.current) return
      const p = Math.min((Date.now() - startTimeRef.current) / LONG_PRESS_DURATION, 1)
      el?.style.setProperty('--lp-p', p)

      if (p < 1) {
        animFrameRef.current = requestAnimationFrame(animate)
      } else {
        isPressing.current = false
        el?.classList.remove('lp-pressing')
        el?.style.removeProperty('--lp-p')
        const rect = el?.getBoundingClientRect()
        if (rect) onComplete(rect)
      }
    }
    animFrameRef.current = requestAnimationFrame(animate)
  }

  const handlePointerMove = (e) => {
    if (!isPressing.current) return
    const dx = Math.abs(e.clientX - startXRef.current)
    const dy = Math.abs(e.clientY - startYRef.current)
    if (dx > MOVE_TOLERANCE || dy > MOVE_TOLERANCE) cancelPress()
  }

  return (
    <tr
      ref={rowRef}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={cancelPress}
      onPointerCancel={cancelPress}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </tr>
  )
}

export default LongPressRow
